<template>
  <div :class="['pagination-controls', { minified: minified }]">
    <nav>
      <button
        :class="[
          'pagination-controls-btn',
          { disabled: onFirstPage || isLoading },
          'pagination-controls-btn__first',
        ]"
        @click="onClickChangePage(0)"
        :aria-label="$t('accessibility.ARIA_FIRST_PAGE')"
      >
        <Icon
          name="goto"
          class="icon__180"
        />
        <Icon
          name="goto"
          class="icon__180"
        />
      </button>
      <button
        :class="[
          'pagination-controls-btn',
          'pagination-controls-btn__prev',
          { disabled: onFirstPage || isLoading },
        ]"
        @click="onClickChangePage(page - 1)"
        :aria-label="$t('accessibility.ARIA_PREVIOUS_PAGE')"
      >
        <Icon
          name="goto"
          class="icon__180"
        />
      </button>
      <div class="pagination-controls-page">
        <Loading
          v-if="isLoading"
          shape="circle"
          :stroke-width="2"
          :size="16"
          rotate
          :indeterminate="true"
        />
        <p
          class="copy bold"
          v-else
        >
          {{ pageNumber }}
        </p>
      </div>
      <button
        :class="[
          'pagination-controls-btn',
          'pagination-controls-btn__next',
          { disabled: onLastPage || isLoading },
        ]"
        @click="onClickChangePage(page + 1)"
        :aria-label="$t('accessibility.ARIA_NEXT_PAGE')"
      >
        <Icon name="goto" />
      </button>
      <button
        :class="[
          'pagination-controls-btn',
          { disabled: onLastPage || isLoading },
          'pagination-controls-btn__last',
        ]"
        @click="onClickChangePage(pageCount - 1)"
        :aria-label="$t('accessibility.ARIA_LAST_PAGE')"
      >
        <Icon name="goto" />
        <Icon name="goto" />
      </button>
    </nav>
    <section class="pagination-controls-inputs">
      <span
        v-if="!minified && page == 0"
        class="pagination-controls-input-container"
      >
        <label
          class="label__options"
          for="pageSize"
        >{{
          $t("labels.PAGINATION_SIZE")
        }}</label>
        <select
          name="pageSize"
          class="input"
          :value="pageSize"
          @change="onChangePageSize"
        >
          <option
            selected
            value="10"
          >10</option>
          <option value="30">30</option>
          <option value="50">50</option>
        </select>
      </span>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Icon from "./Icon.vue";
import Loading from "./Loading.vue";

export default {
  name: "PaginationControls",
  components: {
    Icon,
    Loading,
  },
  props: {
    page: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    pageCount: {
      type: Number,
      required: true,
    },
    minified: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["isLoading"]),
    onFirstPage() {
      return this.page === 0;
    },
    onLastPage() {
      return this.page >= this.pageCount - 1;
    },
    pageNumber() {
      if (this.pageCount === 0) return "-";
      if (!this.minified && this.pageCount > 0)
        return `${this.page + 1} ( ${this.pageCount} )`;
      return this.page + 1;
    },
  },
  methods: {
    onChangePageSize(ev) {
      this.$emit("changePageSize", ev);
    },
    onClickChangePage(val) {
      this.$emit("changePage", val);
    },
  },
};
</script>
